module.exports = __webpack_public_path__ + "2ed58849c03c71d1934fd5af134e6f71.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/fluorescenceScale/faint@2x.png
// module id = 851
// module chunks = 0